import React, { useRef, useState } from "react";
import { Radio, Textarea } from "@material-tailwind/react";
import { MdSend } from "react-icons/md";
import emailjs from "@emailjs/browser";
import { ContactUsOptions } from "constants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showToast } from "utils/showToast";
import { AdminEmail } from "constants";

const RadioOption = ({ label, value, checked, onChange }) => (
  <Radio
    name="contact"
    color="indigo"
    label={label}
    value={value}
    checked={checked}
    onChange={onChange}
  />
);

const ContactUs = () => {
  const navigate = useNavigate();
  const { selectedStore } = useSelector((store) => store.selectedStore);

  const { profile } = useSelector((store) => store.userProfile);
  const form = useRef();
  const [radioValue, setRadioValue] = useState(null);
  const [message, setMessage] = useState("");
  const isSubmitDisabled = !radioValue && message === "";
  const handleRadioChange = (label) => {
    setRadioValue(label);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const messageValue = form.current.message.value;
    const emailParams = {
      subject: radioValue,
      user_email: profile.email,
      user_name: `${profile.first_name}  ${profile.last_name}`,
      message: messageValue,
      to_email: AdminEmail,
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        emailParams,
        process.env.REACT_APP_EMAILJS_PUBLICK_KEY
      )
      .then(
        (result) => {
          form.current.reset();
          showToast("Feedback submitted successfully.", "success", true);
          navigate(`/users/${profile.id}/profile`);
        },
        (error) => {
          console.error("Email sending error:", error.text);
          showToast(error.text, "error", true);
        }
      );
  };

  return (
    <div className="flex justify-center flex-grow min-h-screen align-center ">
      <div className="mt-16 ">
        <form ref={form} onSubmit={sendEmail}>
          <div className="flex flex-col gap-1 mt-16">
            {ContactUsOptions.map((option) => (
              <RadioOption
                key={option.value}
                label={option.label}
                value={option.value}
                checked={radioValue === option.value}
                onChange={() => handleRadioChange(option.value)}
              />
            ))}
          </div>
          <div className="relative mx-2">
            <Textarea
              name="message"
              className=""
              color="indigo"
              label="Message"
              onChange={(e) => setMessage(form.current.message.value)}
            />
            <button
              style={{
                backgroundColor: selectedStore?.theme.backgroundColor,
              }}
              type="submit"
              className={`absolute p-2 rounded-full right-1 bottom-3  ${
                isSubmitDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={isSubmitDisabled}
            >
              <MdSend size={20} className="text-white" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
